import { SectionStyle } from "./Section.module";

const Section = ({ children }) => {
  return <SectionStyle>{children}</SectionStyle>;
};

export default Section;
